<template>
    <div>
        <!-- Overlay com indicador de progresso -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div class="flex flex-col">
            <div class="flex-1 bg-white shadow-xl">
                <v-data-table :headers="headers" :items="vendas" :items-per-page="8">
                    <!-- Coluna de índice -->
                    <template v-slot:item.indice="{ item }">
                        <span>{{ indexOfItem(item) }}</span>
                    </template>
                    <!-- Colunas formatadas com utilitários -->
                    <template v-slot:item.ValorAPagar="{ item }">
                        <span>{{ formatMoney(item.ValorAPagar) }}</span>
                    </template>
                    <template v-slot:item.valorPago="{ item }">
                        <span>{{ formatMoney(item.valorPago) }}</span>
                    </template>
                    <template v-slot:item.desconto="{ item }">
                        <span>{{ formatMoney(item.desconto) }}</span>
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import _axios from '@/plugins/axios';
import utilitarios from '@/plugins/utilitarios';
import Swal from 'sweetalert2';

export default {
    props: {
        funcionario: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            overlay: false,
            vendas: [],
            headers: [
                { text: '#', value: 'indice' },
                { text: 'Autor', align: 'start', sortable: false, value: 'autor' },
                { text: 'Factura', value: 'numeroFatura' },
                { text: 'Estudante', value: 'cliente' },
                { text: 'Operação', value: 'operacao' },
                { text: 'Valor A Pago', value: 'ValorAPagar' },
                { text: 'Valor Pago', value: 'valorPago' },
                { text: 'Desconto', value: 'desconto' },
                { text: 'Data de Realização', value: 'data_realizacao' },
                { text: 'Última Actualização', value: 'modifiedAt' },
            ],
        };
    },
    watch: {
        funcionario: {
            immediate: true,
            handler(newFuncionario) {
                if (newFuncionario) {
                    this.pesquisarVendas();
                }
            },
        },
    },
    methods: {
        // Função para formatar valores monetários
        formatMoney(value) {
            return utilitarios.IntegerToMoneyValueFatura(value);
        },

        // Função para calcular o índice do item
        indexOfItem(item) {
            return this.vendas.indexOf(item) + 1;
        },

        // Busca as vendas do funcionário
        async pesquisarVendas() {
            if (!this.funcionario || !this.funcionario.nomeUsuario) {
                Swal.fire('Erro', 'Funcionário inválido', 'error');
                return;
            }

            try {
                this.overlay = true;
                this.vendas = [];

                const response = await _axios.get(`/registroFuncionario/${this.funcionario.pkUsuario}`);
                this.vendas = response.data;
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro durante a listagem dos pagamentos!', 'error');
            } finally {
                this.overlay = false;
            }
        },
    },
};
</script>

<style scoped></style>